import { useCallback, useEffect, useState } from 'react';
import { api, ApiError } from './api';

/** GET `path` (null = skip). Re-fetches when the path changes; `reload()` forces a refresh. */
export function useApi<T>(path: string | null) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<ApiError | null>(null);
  const [loading, setLoading] = useState(false);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!path) return;
    let alive = true;
    setLoading(true);
    api
      .get<T>(path)
      .then((d) => {
        if (alive) {
          setData(d);
          setError(null);
        }
      })
      .catch((e: unknown) => alive && setError(e instanceof ApiError ? e : new ApiError(0, 'UNKNOWN', String(e))))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [path, tick]);

  const reload = useCallback(() => setTick((t) => t + 1), []);
  return { data, error, loading, reload, setData };
}

export const errMsg = (e: unknown) => (e instanceof Error ? e.message : 'เกิดข้อผิดพลาด');
